import React from 'react'

const ReportTab = () => {
  return (
    <div>ReportTab</div>
  )
}

export default ReportTab;
